import { useMemo } from 'react';
import { useEventMetadataStore } from '../../event-panel/event-panel-form/event-metadata';

export function useCrossClassEventsIds() {
    const eventMetadata = useEventMetadataStore()?.state.metadata;

    return useMemo(
        () =>
            eventMetadata?.linkedAndCrossClassEvents
                ?.filter((eventInfoDto) => !eventInfoDto.isLinkedEvent)
                .map((eventInfoDto) => eventInfoDto.id),
        [eventMetadata]
    );
}
